import {shallowRef, Slots, VNode, watchEffect} from "vue";

export function useDefaultSlot(slots: Slots) {
  // 当前绑定的对象
  const slotNode = shallowRef<VNode | null>(null);
  const el = shallowRef<HTMLElement | null>(null);

  watchEffect(() => {
    if (slotNode.value) {
      el.value = slotNode.value.el as any;
    }
  });

  const getRenderFn = (propsFn: () => any = () => undefined) => {
    return () => {
      if (slots.default) {
        const vNodes = slots.default(propsFn());
        slotNode.value = vNodes[0];
        return vNodes;
      } else {
        throw new Error("没有默认slot");
      }
    };
  };

  return { slotNode, el, getRenderFn };
}
